/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterZ = createReactComponent("letter-z", "IconLetterZ", [
  ["path", { d: "M7 4h10l-10 16h10", key: "svg-0" }]
]);

export { IconLetterZ as default };
//# sourceMappingURL=IconLetterZ.js.map
